import {
  CampaignDesignation,
  Designation,
  DesignationParams,
  DesignationsPageResponse,
  OrganizationDesignation,
} from 'models/Designation'
import toAPIv2QueryString from 'utils/functions/toAPIv2QueryString'

import { api } from '../api'

export const designationsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCampaignDesignations: builder.query<
      DesignationsPageResponse<CampaignDesignation>,
      { campaignId: string; params: DesignationParams }
    >({
      query: ({ campaignId, params }) => ({
        url: `/campaigns/${campaignId}/designations?${toAPIv2QueryString(params)}`,
        method: 'GET',
      }),
    }),
    getOrganizationDesignations: builder.query<
      DesignationsPageResponse<OrganizationDesignation>,
      { organizationId: string; params: DesignationParams }
    >({
      query: ({ organizationId, params }) => ({
        url: `/organizations/${organizationId}/designations?${toAPIv2QueryString(params)}`,
        method: 'GET',
      }),
    }),
    fetchDesignation: builder.query<Designation, { designationId: number | string }>({
      query: ({ designationId }) => ({
        url: `/designations/${designationId}`,
        method: 'GET',
      }),
    }),
  }),
})

export const {
  useGetCampaignDesignationsQuery,
  useGetOrganizationDesignationsQuery,
  endpoints: { getCampaignDesignations, getOrganizationDesignations, fetchDesignation },
} = designationsApi
